import { gql } from "@apollo/client";

export const FETCH_MANAGE_STAFF_PAGE = gql`
  query FetchManageStaffPage {
    manageUsersPage {
      title
      description
      staffListTitle
      inviteStaff {
        title
        description
        inviteStaff
        importStaffSpreadsheet
        toastStaffInvitedTitle
        toastStaffInvitedDescription
        dialogTitle
        dialogDescription
        dialogConfirmButton
      }
      staffImportFromSpreadsheetDialog {
        title
        description
        closeButtonText
        importStaffButtonText
        uploadFileButtonText
        previewTitle
        toastStaffImportedTitle
        toastStaffImportedDescription
      }
      staffEmptyState {
        title
        description
      }
      staffStatus {
        pendingInviteMessage
        invitedPendingSignUpMessage
        registeredPendingOnboardingMessage
        registeredOnboardedMessage
        invitedPendingSignUpColor
        registeredPendingOnboardingColor
        registeredOnboardedColor
        pendingInviteColor
      }
    }
  }
`;
